import React from 'react';
import { Alert, BannerAlert, BannerAlertVariant, Icon } from '@amzn/storm-ui';
import { BANNER_TYPE, LocalNotification } from '@amzn/aac-chrome-internal-api';
import { bannerIconMap } from '../types';
import { ConnectedBannerContent } from 'src/commons/components/ConsolidatedBanner/BannerContent';
import { BANNER_LEVEL } from 'src/app/slice';
import { BannerText } from '../styles';

interface SingleBannerProps {
  banner: LocalNotification;
  onDismissClick: (dismissBanner: LocalNotification) => void;
  bannerLevel: BANNER_LEVEL;
  isRenderedInModal?: boolean;
}

export const SingleBanner: React.VFC<SingleBannerProps> = ({
  banner,
  onDismissClick,
  bannerLevel,
  isRenderedInModal = true,
}) => {
  const isConsoleLevel = bannerLevel === BANNER_LEVEL.CONSOLE;
  const canDismissBanner = banner.type !== BANNER_TYPE.ERROR;

  return (
    <>
      {isConsoleLevel ? (
        <BannerAlert
          data-test-id="single-banner"
          variant={banner.type.toLowerCase() as BannerAlertVariant}
          withCloseButton={canDismissBanner}
          onClose={() => onDismissClick(banner)}
        >
          <BannerText>
            {isConsoleLevel && isRenderedInModal && (
              <Icon type={bannerIconMap[banner.type]} />
            )}
            <ConnectedBannerContent
              banner={banner}
              bannerLevel={bannerLevel}
              isRenderedInModal={isRenderedInModal}
            />
          </BannerText>
        </BannerAlert>
      ) : (
        <Alert
          data-test-id="single-banner"
          variant={banner.type.toLowerCase() as BannerAlertVariant}
          withCloseButton={canDismissBanner}
          onClose={() => onDismissClick(banner)}
          header={banner.title}
        >
          <BannerText>
            {isConsoleLevel && isRenderedInModal && (
              <Icon type={bannerIconMap[banner.type]} />
            )}
            <ConnectedBannerContent
              banner={banner}
              bannerLevel={bannerLevel}
              isRenderedInModal={isRenderedInModal}
            />
          </BannerText>
        </Alert>
      )}
    </>
  );
};
